export default __webpack_public_path__ + "static/media/Fullmouth1.11065b61.png";